import { LegacyPortalSearchAvailabilityStatus } from "@spwn-portal/grpc/build";

type Output = LegacyPortalSearchAvailabilityStatus[];
type ConvertToLegacyPortalSearchAvailabilityStatus = (
  previousValue: LegacyPortalSearchAvailabilityStatus[],
  input: string
) => Output;

const LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_VALUES = new Set(
  Object.values(LegacyPortalSearchAvailabilityStatus)
);

export const convertToLegacyPortalSearchAvailabilityStatus: ConvertToLegacyPortalSearchAvailabilityStatus =
  (previousValue, currentValue) => {
    const numberInput = Number(currentValue);
    if (!LEGACY_PORTAL_SEARCH_AVAILABILITY_STATUS_VALUES.has(numberInput))
      return previousValue;

    previousValue.push(numberInput);
    return previousValue;
  };
